import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Fade,
  Stack,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { AuthContext } from "../context/auth/authContext";
import logoSmall from "../images/png/logo_small.png";
import { theme } from "../utilities/themes";
import OTPInput from "otp-input-react";
import { countryList } from "../utilities/countryList";

import "react-phone-input-2/lib/material.css";
import PhoneInput from "react-phone-input-2";
import dayjs from "dayjs";

const AuthDialog = ({
  open,
  setOpen,
  title = "SIGN IN",
  subTitle,
  onLogin = () => {},
  onFail = () => {},
}) => {
  const [phone, setPhone] = useState("");
  const [OTP, setOTP] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const authContext = useContext(AuthContext);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [counter, setCounter] = useState(60);
  const [sendingCode, setSendingCode] = useState(true);

  const handleClose = () => {
    setOpen(false);
    setOTP("");
    setLoading(false);
    setError("");
    setResendDisabled(true);
    setCounter(60);
    setSendingCode(true);
  };
  const sendCode = () => {
    if (phone.length === 12) {
      setLoading(true);
      authContext
        .sendCode(phone)
        .then(() => {
          setLoading(false);
          setSendingCode(false);
        })
        .catch((error) => {
          setLoading(false);
        });
      startTimer();
    }
  };

  const login = () => {
    setLoading(true);

    authContext
      .loginFunc(phone, OTP)
      .then((loggedIn) => {
        setLoading(false);
        if (loggedIn) onLogin(phone);
        else onFail(phone);
        handleClose();
      })
      .catch((error) => {
        setLoading(false);
        onFail(phone);
        handleClose();
      });
  };

  const startTimer = () => {
    setResendDisabled(true);
    setCounter(60);
    let startTime = dayjs().valueOf();
    let interval = setInterval(() => {
      setCounter(60 - Math.floor((dayjs().valueOf() - startTime) / 1000));
    }, 1000);
    setTimeout(() => {
      clearInterval(interval);
      setResendDisabled(false);
    }, 60000);
  };

  const handleLogIn = () => {
    if (sendingCode) {
      sendCode();
    } else {
      login();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          overflowY: "visible",
        },
      }}
    >
      <DialogTitle>
        <Stack direction="row" minHeight="4vh" spacing={1} alignItems="center">
          <Box sx={{ width: "40px" }}>
            <img src={logoSmall} alt="logo" style={{ width: "100%" }} />
          </Box>
          <Typography variant="h5" color={theme.palette.primary.main}>
            {title}
          </Typography>
        </Stack>
      </DialogTitle>
      {subTitle && sendingCode && (
        <DialogContent>
          <DialogContentText>{subTitle}</DialogContentText>
        </DialogContent>
      )}
      <ValidatorForm onSubmit={handleLogIn}>
        <Stack spacing={1}>
          {sendingCode ? (
            <Fade in>
              <Stack spacing={1} p={2}>
                <PhoneInput
                  country={"ke"}
                  value={phone}
                  onChange={(phone, data) => {
                    setPhone(phone);
                  }}
                  inputStyle={{
                    maxWidth: "100%",
                    width: "max-content",
                  }}
                  placeholder="+254x xxx xxx"
                  onlyCountries={countryList}
                  defaultErrorMessage="Phone number is invalid"
                  isValid={phone.length === 12}
                />
              </Stack>
            </Fade>
          ) : (
            <Fade in>
              <Stack spacing={1} p={2}>
                <Typography variant="span">
                  We have sent you a code via sms
                </Typography>
                <Typography variant="span">Enter the code:</Typography>
                <OTPInput
                  value={OTP}
                  onChange={setOTP}
                  autoFocus
                  OTPLength={4}
                  otpType="number"
                  disabled={false}
                />
              </Stack>
            </Fade>
          )}

          {error && (
            <Collapse in>
              <Typography sx={{ pl: 2 }} variant="body1" color="red">
                {error}
              </Typography>
            </Collapse>
          )}
          <DialogContentText sx={{ pl: 2 }}>
            By continuing, you agree to our{" "}
            <a
              style={{
                color: theme.palette.primary.main,
              }}
              href="https://little.africa/tnc_ind.php"
            >
              terms and conditions
            </a>
          </DialogContentText>
        </Stack>
        <DialogActions>
          <Button onClick={() => handleClose()}>Cancel</Button>

          {!sendingCode && (
            <Button
              disabled={resendDisabled}
              onClick={() => setSendingCode(true)}
            >
              Re-send code {counter > 0 && <>&#40;{counter}&#41;</>}
            </Button>
          )}
          <Button
            variant="contained"
            sx={{ width: "fit-content" }}
            type="submit"
            disabled={loading}
          >
            {loading && (
              <>
                <CircularProgress size={16} />
                &nbsp;
              </>
            )}
            {sendingCode ? <>Continue</> : <>Verify</>}
          </Button>
        </DialogActions>
      </ValidatorForm>
    </Dialog>
  );
};
export default AuthDialog;
